import axios from 'axios';

import { API } from '@/config/constants';


const photoUrl = (productId, size) => (
  `${API}/products/${productId}/photo${size ? `?size=${encodeURIComponent(size)}` : ''}`
);


export const getProducts = async (config) => {
  const response = await axios.get(`${API}/products`, ...(config ? [config] : []));
  return response.data;
};

export const getProduct = async (productId, config) => {
  const response = await axios.get(`${API}/products/${productId}`, ...(config ? [config] : []));
  return response.data;
};

export const createProduct = async (data, config) => {
  const response = await axios.post(`${API}/products`, data, ...(config ? [config] : []));
  return response.data;
};

export const updateProduct = async (productId, data, config) => {
  const response = await axios.put(`${API}/products/${productId}`, data, ...(config ? [config] : []));
  return response.data;
};

export const deleteProduct = async (productId, config) => {
  const response = await axios.delete(`${API}/products/${productId}`, ...(config ? [config] : []));
  return response.data;
};

export const uploadProductPhoto = async (productId, size, file, config = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(photoUrl(productId, size), formData, {
    ...config,
    headers: { ...config.headers, 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteProductPhoto = async (productId, size, config) => {
  const response = await axios.delete(photoUrl(productId, size), ...(config ? [config] : []));
  return response.data;
};
